import { useParams } from "react-router-dom";
import { useGetCertificateById } from "@/hooks/compliance/compliance.hook";
import { useDownloadCertificateMutation } from "@/hooks/file-upload/file-upload.hook";
import { useEffect } from "react";
import { toast } from "@/utils/toast";

const PublicCertificateViewPage = () => {
    const { id } = useParams<{ id: string }>();
    const { data: certificate, isLoading, isError } = useGetCertificateById(id || "");

    const getCertificateStreamKey = (cert: typeof certificate): string | null => {
        const downloadUrl = (cert as { downloadUrl?: string })?.downloadUrl?.trim();
        if (!downloadUrl) return null;
        if (downloadUrl.startsWith("/certificates") || downloadUrl.startsWith("certificates")) {
            return "/" + downloadUrl.replace(/^\/+/, "");
        }
        const i = downloadUrl.toLowerCase().indexOf("pencom");
        if (i === -1) return null;
        const path = downloadUrl.slice(i + 6).replace(/^\/*/, "");
        return path ? `/${path}` : null;
    };

    const certificateStreamKey = getCertificateStreamKey(certificate);

    const { mutateAsync: downloadCertificate, isPending: isDownloadingCertificate, isError: isDownloadingCertificateError } = useDownloadCertificateMutation();

    const handleDownloadCertificate = async () => {
        try {
            if (!certificateStreamKey) return;
            const blob = await downloadCertificate(certificateStreamKey);

            console.log(blob);

            const url = URL.createObjectURL(blob);

            console.log(url);

            const link = document.createElement("a");
            link.href = url;
            link.target = "_self"; // open in new tab
            link.rel = "noopener noreferrer";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // optional delay
            setTimeout(() => URL.revokeObjectURL(url), 2000);
        } catch {
            toast.error("Failed to load certificate. Please try again.");
        }
    };

    useEffect(() => {
        if (certificateStreamKey) {
            handleDownloadCertificate();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [certificateStreamKey]);



    if (isLoading || isDownloadingCertificate) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-50">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-button mx-auto mb-4"></div>
                    <p className="font-clash-display text-medium-dark-grey">Loading certificate...</p>
                </div>
            </div>
        );
    }

    if (isError || !certificate || !certificate.downloadUrl || isDownloadingCertificateError) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-50">
                <div className="text-center">
                    <img src="/assets/icons/round-cancel.svg" alt="Error" className="w-16 h-16 mx-auto mb-4" loading="lazy" />
                    <h1 className="font-clash-display font-semibold text-xl text-medium-dark-grey mb-2">
                        Certificate Not Found
                    </h1>
                    <p className="font-clash-display text-medium-grey">
                        The certificate you're looking for could not be found.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white">
            <iframe
                src={certificate.downloadUrl}
                className="w-full h-screen border-0"
                title="Certificate PDF"
            />
        </div>
    );
};

export default PublicCertificateViewPage;

